import GenericDataContext from "./GenericDataContext";

export default GenericDataContext;